export const extractUrlParam = (key: string, url: string): string | null => {
    return new URL(url).searchParams.get(key);
};
